module.exports = __webpack_public_path__ + "img/8.c1c76856.jpg";